import "./BisDialog.css";
import {Button} from '@radix-ui/themes';
import * as Dialog from '@radix-ui/react-dialog';
import {useId} from "react";
import PropTypes from 'prop-types';


const BisDialog = ({isOpen, onClose, title, description, children}) => {
    const descriptionId = useId()

    return (
        <Dialog.Root open={isOpen} onOpenChange={(open) => {
            if (!open) onClose();
        }}>
            <Dialog.Portal>
                <Dialog.Overlay className="dialog-overlay"/>
                <Dialog.Content className="dialog-content"
                                aria-modal="true"
                                aria-describedby={description ? descriptionId : undefined}
                >
                    <div className="dialog-header">
                        <div className="dialog-title-container">
                            <Dialog.Title className="dialog-title-text">
                                {title}
                            </Dialog.Title>
                            <Dialog.Close asChild>
                                <Button variant="ghost" aria-label="Schließen">
                                    x
                                </Button>
                            </Dialog.Close>
                        </div>
                        <div className="dialog-title-line"></div>
                    </div>
                    {description && (
                        <Dialog.Description id={descriptionId} className="dialog-description">
                            {description}
                        </Dialog.Description>
                    )}

                    <div className="dialog-body">
                        {children}
                    </div>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};

BisDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};

export default BisDialog;
